export var actionTypePrefix = '@@CommentThread';
export var commentOffsetParamName = 'comment';
export var COMMENT_THREAD_STREAM_GROUP_ID = 'COMMENT_THREAD_STREAM_GROUP_ID';
// Default maximum depth of a thread before we show the "View X replies" button.
// Individual projects may use their own setting.
export var THREAD_MAX_DEPTH = 7;
export var THREAD_MAX_DEPTH_MOBILE = 2;
// Threads in comment modals must display all comments regardless of how deep
// they are, in practice we can pass a very high number as a max depth.
export var COMMENT_MODAL_THREAD_MAX_DEPTH = 10000;
// Don't place the lower comment editor/postbox when there are fewer than this
// number of comments loaded
export var MIN_COMMENT_COUNT_TO_SHOW_BOTTOM_POST = 6;
// Number of comments per fetch. A different value can be passed in initializeThread.
export var DEFAULT_ITEMS_PER_FETCH = 50;
//# sourceMappingURL=constants.js.map